import API from '@/api'

const actions = {
  getCollection({ commit }, payload) {
    API.orders.getCollection(payload)
      .then(({ data: { data, include, meta } }) => {
        if (meta.page === 1) {
          commit('setCollection', data)
          commit('setIncludes', include)
        } else {
          commit('updateCollection', data)
        }

        commit('setPagination', meta)
      })
      .catch(() => {
        commit('setIsLoadingError', true)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  }
}

export default actions